var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"modified-loader loader loading_whole",staticStyle:{"height":"100vh"}},[_c('loading')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }